var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLines = function SvgLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 322 142"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5918_183907)",
    fillRule: "evenodd",
    d: "M72.297 132.488c-3.456-7.985.232-17.253 8.237-20.7l219.42-94.494c8.005-3.447 17.294.232 20.749 8.218 3.456 7.985-.232 17.253-8.237 20.7l-219.42 94.494c-8.005 3.447-17.294-.232-20.75-8.218",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_5918_183907)",
    fillRule: "evenodd",
    d: "M28.658 105.274c-1.741-3.98.093-8.608 4.097-10.338L250.941.654c4.004-1.73 8.661.093 10.401 4.072s-.093 8.608-4.097 10.338L39.059 109.346c-4.004 1.731-8.66-.093-10.401-4.072",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_5918_183907)",
    fillRule: "evenodd",
    d: "M237.223 27.737c2.07 4.817-.139 10.408-4.934 12.487L13.207 135.22c-4.795 2.079-10.36-.14-12.43-4.957s.14-10.408 4.934-12.487L224.793 22.78c4.795-2.079 10.36.14 12.43 4.957",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5918_183907",
    x1: 321.462,
    x2: 72.681,
    y1: 13.469,
    y2: 13.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5918_183907",
    x1: 261.499,
    x2: 29.567,
    y1: -2.21,
    y2: -2.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5918_183907",
    x1: 0.51,
    x2: 236.406,
    y1: 138.29,
    y2: 138.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })))));
};
export default SvgLines;